import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const MENUITEMS = [
  { url: "/dashboard", text: "Batches" },
  { url: "/ledgers", text: "Ledgers" },
];

const PrudentialAppLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const useremail = window.APPUSER?.user?.email || "User";

  let pagetitle = "Prudential";
  if (pathname == "/review") pagetitle = "Review";
  for (let i = 0; i < MENUITEMS.length; i++) {
    if (MENUITEMS[i].url == pathname) {
      pagetitle = MENUITEMS[i].text;
    }
  }

  const signout = () => {
    localStorage.removeItem(window.APPSETTING.appname + "user");
    navigate('/login');
  };

  const menuitems = [];
  for (let i = 0; i < MENUITEMS.length; i++) {
    const item = MENUITEMS[i];
    menuitems.push(
      <div
        key={item.url}
        className={"nav-item " + (pathname == item.url ? "active" : "")}
        onClick={() => navigate(item.url)}
      >
        {item.text}
      </div>
    );
  }

  return (
    <div className="dash-wrapper">
      <aside className="dash-sidebar">
        <div className="dash-sidebar-header">Prudential Auditing</div>
        <nav className="dash-nav">{menuitems}</nav>
      </aside>

      <div className="dash-main">
        <header className="dash-header">
          <h1 className="dash-title">{pagetitle}</h1>
          <span className="dash-user">{useremail}</span>
          <button className="btn-signout" onClick={signout}>Sign out</button>
        </header>
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrudentialAppLayout;
